const ACADEMIC_SUBJECTS = ['Reading', 'Writing', 'Math']

export const SUBJECT_TYPES = {
  ACADEMIC: 'Academic',
  ALT: 'Alt',
  OTHER: 'Other'
}

export function isAcademicSubject(subjectName) {
  return ACADEMIC_SUBJECTS.includes(subjectName)
}

